import { ethers } from "ethers";
import { MySigner, getContract } from "../hooks/getContract";
import { useEffect, useState } from 'react';
import Countdown from 'react-countdown';
import { useNavigate } from "react-router-dom";
import { etherUnits } from "viem";
import { useAccount } from "wagmi";

export default function Nftcard() {

    const [Auction, setAuction] = useState([])
    const Navigate = useNavigate()
    const { address, isConnected } = useAccount()

    const test = isConnected ? MySigner : null
    const AuctionContract = getContract(test)
    const Array = []

    async function Data() {
        const AuctionCount = await AuctionContract.TotalAuction()
        const ActiveAuctionId = await AuctionContract.getOngoingAuctionIds()
        for (let i = 1; i <= AuctionCount; i++) {
            const AuctionData = await AuctionContract.auctions(i)

            Array.push(AuctionData);
        }
        setAuction(Array)
    }
    console.log(Auction);

    async function Detail(e) {
        Navigate(`/details?id=${e}`)
    }

    useEffect(() => {
        Data()
    }, [])

    return (<>

        <div className="mb-16 grid grid-cols-1 gap-8 px-4 sm:px-0 md:grid-cols-3 xl:grid-cols-5" style={{ marginTop: '70px' }}>

            {Auction ? Auction.map((pack, i) => (
                <div class="card">
                    <div class="img">
                        <img src={pack.Img} width='100%' height='100%' />

                    </div>

                    <div class="text">
                        <p class="h3"> NFT - {i + 1}
                            <br />
                            <span style={{ color: '#8F51EA' }}>
                                {(parseInt(pack?.auctionEndTime) < Math.floor(Date.now() / 1000)) && "Sale ended" ||
                                    <>
                                        Sale Ends: <Countdown date={parseInt(pack?.auctionEndTime) * 1000} />

                                    </>
                                }
                            </span>
                        </p>
                        <p class="p">{ethers.utils.formatEther(pack.basePrice)} MATIC</p>

                        <div class="icon-box" onClick={() => Detail(i + 1)}>
                            <p class="span">Buy Now
                            </p></div>
                    </div>
                </div>
            )) : <></>}
        </div>

    </>)
}